export const PRICE_TIER = {
  DIGITAL: '9.99',
  MAGAZINE: '8.99',
  FULL_ACCESS: '11.99',
  FULL_ACCESS_INTRO: '5',
} as const
